// Lot 642 — intensité du lissage « Beauté » du direct (0 = désactivé … 100), mémorisée sur l'appareil.
const KEY = "yalola.live.beauty";

export const clampBeauty = (v) => {
  const n = Math.round(Number(v));
  return Number.isFinite(n) ? Math.min(100, Math.max(0, n)) : 0;
};

export const readBeauty = () => { try { return clampBeauty(localStorage.getItem(KEY) ?? 0); } catch { return 0; } };
export const writeBeauty = (v) => { try { localStorage.setItem(KEY, String(clampBeauty(v))); } catch { /* noop */ } };

// Web (canvas) : flou + éclat proportionnels à l'intensité.
export const beautyCss = (v) => {
  const t = clampBeauty(v) / 100;
  if (!t) return "none";
  return `brightness(${(1 + 0.12 * t).toFixed(3)}) saturate(${(1 + 0.16 * t).toFixed(3)}) contrast(${(1 + 0.03 * t).toFixed(3)}) blur(${(1.2 * t).toFixed(2)}px)`;
};

// Natif : le lissage GPU n'éclaircit pas → petit gain lumière/saturation porté par la matrice couleur (lib/mediaFx).
export const beautyBoost = (v) => {
  const t = clampBeauty(v) / 100;
  if (!t) return {};
  return { brightness: 100 + Math.round(8 * t), contrast: 100 + Math.round(2 * t), saturation: 100 + Math.round(10 * t) };
};
